import React, {useRef} from 'react'
import MenuItem from './MenuItem'
import {useStore} from 'react-hookstore'

export default function SideNav () {
  const [, setSidebar] = useStore('sidebar')
  let divStyle = {
    fontSize: '3em',
    padding: '0 0 0 0.3em'
  }
  const closeSideBar = () => {
    setSidebar({
      open: false,
      body: <></>
    })
    document.body.style.overflow = 'visible'
  }
  /*
  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setSidebar({display:'none'})
    document.body.style.overflow = 'visible'
  }
  */
  const node = useRef(<div/>)
  let key=0
  //document.addEventListener("mousedown", handleClickOutside)
  return(
    <div className='sidenav' ref={node}>
      <MenuItem key={key++}>
        <content>pastors</content>
      </MenuItem>
      <MenuItem key={key++}>
        <content>readings</content>
      </MenuItem>
      <MenuItem key={key++}>
        <content>calendar</content>
      </MenuItem>
      <div><hr/></div>
      <MenuItem key={key++}>
        <content>confession</content>
      </MenuItem>
      <MenuItem key={key++}>
        <content>adoration</content>
      </MenuItem>
      <div><hr/></div>
      <MenuItem key={key++}>
        <content>sick</content>
      </MenuItem>
      <MenuItem key={key++}>
        <content>troops</content>
      </MenuItem>
      <MenuItem key={key++}>
        <content>gift</content>
      </MenuItem>
      <MenuItem key={key++}>
        <content>family</content>
      </MenuItem>
      <div onClick={closeSideBar} style={divStyle}>&times;</div>
    </div>
  )

}
